import React from "react";

import {
  type DesignElement,
  type DesignElementBase,
} from "./design-element-manager";

export const createIcon = (
  icon: string,
  bgColor: string,
  borderColor: string,
  size: string,
) => `
  <svg
    width="${size}"
    height="${size}"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <circle
      cx="12"
      cy="12"
      r="11.75"
      fill="#FFFFFF"
    />
    <circle
      cx="12"
      cy="12"
      r="11.5"
      fill="${bgColor}"
      stroke="${borderColor}"
      strokeWidth="0.5"
    />
    ${icon}
  </svg>
`;

const hexToRgb = (hex: string, alpha = "1") => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getLighterColor = (color: string, alpha = "0.1") =>
  hexToRgb(color, alpha);

export const createGetComponentFunc = (
  designElement: DesignElementBase,
): DesignElement => ({
  ...designElement,
  isPreset: false,
  getComponent({ className, borderColor, size, iconBackgroundColor } = {}) {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: designElement.getIcon({
            borderColor,
            size,
            iconBackgroundColor,
          }),
        }}
        className={className}
      />
    );
  },
});
